import Swiper from 'swiper';

export function initializeSearchBar() {
    new SearchBar();
}

class SearchBar {
    readonly OpenClass: string = "open";
    readonly DefaultHeight: number = document.querySelector(".header-inner:not(.small-header)") as HTMLElement != null ? (document.querySelector(".header-inner:not(.small-header)") as HTMLElement).offsetHeight : 0;
    readonly SearchBarHeight: number = document.querySelector(".nav-search.open") as HTMLElement != null ? (document.querySelector(".nav-search.open") as HTMLElement).offsetHeight : 0;


    displayToggle: HTMLElement;
    searchBarContainer: HTMLElement;

    constructor() {
        this.displayToggle = document.querySelector("[data-search-toggle]");
        this.searchBarContainer = document.querySelector("[data-search-container]");
        if (this.displayToggle) {
            this.displayToggle.addEventListener("click", this.handleDisplayToggleClick);
        }
    }

    handleDisplayToggleClick = (e) => {
        e.preventDefault();
        e.stopPropagation();

        if (this.displayToggle.classList.contains(this.OpenClass)) {
            let marginTop = null;

            this.searchBarContainer.classList.remove(this.OpenClass);
            this.displayToggle.classList.remove(this.OpenClass);

            if (this.DefaultHeight != null && this.SearchBarHeight != null) {
                marginTop = this.DefaultHeight - this.SearchBarHeight;
            }

            if (marginTop != null) {
                document.body.style.setProperty('margin-top', `${marginTop}px`);
            }
        }
        else {
            this.searchBarContainer.classList.add(this.OpenClass);
            this.displayToggle.classList.add(this.OpenClass);
        }
    }
}